import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "¿Funciona sin conexión a internet?",
    answer: "Sí, Raven funciona completamente offline. Los técnicos pueden registrar trabajos, tomar fotos y completar checklists sin conexión. Cuando recuperan la conexión, todos los datos se sincronizan automáticamente con la nube."
  },
  {
    question: "¿Puedo usarlo desde el móvil?",
    answer: "Absolutamente. Raven es una PWA (Progressive Web App) que se puede instalar como una app nativa en cualquier dispositivo móvil, tablet u ordenador. Funciona en Android, iOS, Windows y Mac."
  },
  {
    question: "¿Los datos están seguros?",
    answer: "Sí, todos los datos están cifrados y almacenados en servidores seguros con backup automático. Cumplimos con las normativas de protección de datos y privacidad (GDPR)."
  },
  {
    question: "¿Cuántos usuarios puedo tener?",
    answer: "Puedes agregar tantos usuarios como necesites (administradores, técnicos, etc.). Cada plan incluye un número de usuarios, y puedes ampliar según crezca tu equipo."
  },
  {
    question: "¿Cómo es el proceso de implementación?",
    answer: "RAVEN está listo para usar desde el momento en que creas tu cuenta. No necesitas servidores dedicados ni instalaciones técnicas - simplemente accedes y empiezas a trabajar. Si tienes datos existentes que quieras migrar (clientes, contratos, históricos), te acompañamos en ese proceso. El soporte continuo está incluido según tu plan de suscripción."
  },
  {
    question: "¿Necesito contratar servidores o personal técnico?",
    answer: "No. RAVEN funciona 100% en la nube y está listo para usar al instante. No necesitas infraestructura propia, personal de IT, ni configuraciones complejas. Simplemente creas tu cuenta y comienzas a gestionar tu empresa."
  },
  {
    question: "¿Ofrecen soporte técnico?",
    answer: "Sí, ofrecemos soporte técnico completo por email, chat y teléfono. También incluimos capacitación inicial para tu equipo y documentación detallada."
  },
  {
    question: "¿Puedo generar informes y documentos?",
    answer: "Sí, Raven genera automáticamente partes de trabajo en PDF con fotos y firmas, facturas, presupuestos, y mandatos SEPA. También puedes exportar informes personalizados en Excel."
  },
  {
    question: "¿Se integra con otros sistemas?",
    answer: "Actualmente estamos trabajando en integraciones con sistemas de facturación y contabilidad. Contáctanos para conocer las integraciones disponibles y en desarrollo."
  }
];

export function LandingFAQ() {
  return (
    <section id="faq" className="py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-raven-violet/10 blur-3xl" />
      
      <div className="container mx-auto max-w-4xl relative z-10">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            Preguntas <span className="landing-gradient-text">Frecuentes</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Resolvemos tus dudas sobre Raven
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="landing-glass-card px-6 border-none group"
              style={{
                animation: 'fade-in 0.5s ease-out backwards',
                animationDelay: `${index * 0.05}s`
              }}
            >
              <AccordionTrigger className="text-left font-semibold hover:no-underline hover:text-raven-electric transition-colors py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-5 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
